module.exports = __webpack_public_path__ + "static/media/arbre-jaune.99e01e89.png";